import { Field, Form, Formik } from 'formik';
import { useNavigate } from 'react-router-dom';
import useUserOrg from '../../Authentication/components/hooks/useUserOrg';
import { useDeviceGroup } from './hooks/useDeviceGroup';
import { Button } from '@/src/shadComponents/ui/button';
import { Input } from '@/src/shadComponents/ui/input';
import { Label } from '@/src/shadComponents/ui/label';
import {
    Card,
    CardContent,
    CardHeader,
    CardTitle,
} from '@/src/shadComponents/ui/card';

interface CreateDeviceKeyFormValues {
    name: string;
    orgId: number;
}

export default function CreateDeviceGroup() {
    const { orgId } = useUserOrg();
    const navigate = useNavigate();
    const { createDeviceGroup } = useDeviceGroup(orgId);
    const initialValues: CreateDeviceKeyFormValues = {
        name: '',
        orgId,
    };

    return (
        <div className="p-6">
            <div className="mb-6">
                <p className="text-sm text-muted-foreground">Create</p>
                <h1 className="mt-1 text-2xl font-bold tracking-tight text-foreground">
                    Add Device Group
                </h1>
                <p className="mt-1 text-sm text-muted-foreground">
                    Device groups are used to link multiple devices to an
                    activation.
                </p>
            </div>

            <Card>
                <CardHeader>
                    <CardTitle>Device Group Details</CardTitle>
                    <p className="text-sm text-muted-foreground">
                        Enter the name of the device group you want to create.
                    </p>
                </CardHeader>
                <CardContent>
                    <Formik
                        initialValues={initialValues}
                        onSubmit={async (values, actions) => {
                            const wasSuccessful =
                                await createDeviceGroup(values);
                            actions.setSubmitting(false);

                            if (wasSuccessful) {
                                navigate(-1);
                            }
                        }}
                    >
                        {(props) => (
                            <Form
                                className="space-y-6"
                                placeholder={undefined}
                                onPointerEnterCapture={undefined}
                                onPointerLeaveCapture={undefined}
                            >
                                <div className="space-y-2">
                                    <Label htmlFor="name">Group Name</Label>
                                    <Field
                                        as={Input}
                                        id="name"
                                        name="name"
                                        placeholder=""
                                        className="max-w-md"
                                    />
                                </div>

                                <div className="flex items-center gap-2">
                                    <Button
                                        type="submit"
                                        disabled={props.isSubmitting}
                                    >
                                        Create Device Group
                                    </Button>
                                    <Button
                                        type="button"
                                        variant="outline"
                                        onClick={() => navigate(-1)}
                                    >
                                        Cancel
                                    </Button>
                                </div>
                            </Form>
                        )}
                    </Formik>
                </CardContent>
            </Card>
        </div>
    );
}
